import { render, staticRenderFns } from "./RevenuePerSalesChannel.vue?vue&type=template&id=7a4ca8b4&scoped=true&"
import script from "./RevenuePerSalesChannel.vue?vue&type=script&lang=js&"
export * from "./RevenuePerSalesChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ca8b4",
  null
  
)

export default component.exports